export default __webpack_public_path__ + "static/media/verticalCollage.2f483a85.png";